module.exports = __webpack_public_path__ + "img/wx-img.png";